// Auth Types
export const SET_REGISTER = "SET_REGISTER";
export const FETCH_REGISTER_USER = "FETCH_REGISTER_USER";
export const VALIDATE_ERRORS = "VALIDATE_ERRORS";
export const VERIFY_USER = "VERIFY_USER";
export const CREATE_PLAN_PURCHASE_LINK = "CREATE_PLAN_PURCHASE_LINK";
export const LOGIN = "LOGIN";
export const SET_LOGIN_USER = "SET_LOGIN_USER";
export const SELECT_PLAN = "SELECT_PLAN";

// Store Types
export const SET_STORE = "SET_STORE";
export const FETCH_STORES = "FETCH_STORES";

// Division Crud Types
export const FETCH_DIVISIONS = "FETCH_DIVISIONS";
export const FETCH_DIVISION = "FETCH_DIVISION";
export const CREATE_DIVISION = "CREATE_DIVISION";
export const UPDATE_DIVISION = "UPDATE_DIVISION";
export const DELETE_DIVISION = "DELETE_DIVISION";

// District Crud Types
export const FETCH_DISTRICTS = "FETCH_DISTRICTS";
export const FETCH_DISTRICT = "FETCH_DISTRICT";
export const CREATE_DISTRICT = "CREATE_DISTRICT";
export const UPDATE_DISTRICT = "UPDATE_DISTRICT";
export const DELETE_DISTRICT = "DELETE_DISTRICT";

// Sub District Crud Types
export const FETCH_SUB_DISTRICTS = "FETCH_SUB_DISTRICTS";
export const FETCH_SUB_DISTRICT = "FETCH_SUB_DISTRICT";
export const CREATE_SUB_DISTRICT = "CREATE_SUB_DISTRICT";
export const UPDATE_SUB_DISTRICT = "UPDATE_SUB_DISTRICT";
export const DELETE_SUB_DISTRICT = "DELETE_SUB_DISTRICT";

// PostOffice Crud Types
export const FETCH_POST_OFFICES = "FETCH_POST_OFFICES";
export const FETCH_POST_OFFICE = "FETCH_POST_OFFICE";
export const CREATE_POST_OFFICE = "CREATE_POST_OFFICE";
export const UPDATE_POST_OFFICE = "UPDATE_POST_OFFICE";
export const DELETE_POST_OFFICE = "DELETE_POST_OFFICE";

// Staff Crud Types
export const CREATE_STAFF = "CREATE_STAFF";

// Pricing Crud Types
export const FETCH_PRICING_PLANS = "FETCH_PRICING_PLANS";

// Utils Types
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const TOGGLE_NOTIFICATION = "TOGGLE_NOTIFICATION";
export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const TOGGLE_PURCHASE_MODAL = "TOGGLE_PURCHASE_MODAL";
